/**
 * jQuery shim for accessing WordPress's global jQuery
 * This allows ES modules to use WordPress's enqueued jQuery
 */

// Access jQuery from the global window object
const jQuery = window.jQuery || window.$;

if (!jQuery) {
  console.error('jQuery is not loaded. Make sure WordPress jQuery is enqueued.');
}

export default jQuery;
export { jQuery as $ };

